import { Program } from "@project-serum/anchor";
import { TweeterDapp } from "../types/tweeter_dapp";
import { Connection, Keypair } from "@solana/web3.js";
import { getPublicKeys } from "../utils/Pagination";
import { useContext, useEffect, useState, createContext } from "react";
import { TweetsContext } from "./TweetsContext";
import { ConnectionContext } from "./ConnectionProviderContext";
import { ReactNode } from "react";
export const LikeContext = createContext({
    allLikes: [],
    setLikes: (likes: Array<any>) => {},
    setFetch:() => {},
    fetchTweets: false
});

interface WorkSpace {
    program?:Program<TweeterDapp>,
    connection?: Connection,
    wallet?: Keypair
  
  }

const LikesProvider = ({
    children,
}:{ children: ReactNode }  ) => {
    // const {allTweets, fetchTweets} = useContext<any>(TweetsContext);
    const {workSpace}: any = useContext(ConnectionContext);
    const program: Program = workSpace.program;
    const wallet = workSpace.wallet;
    const [allLikes, setAllLikes] = useState<any | null>([]);
    const [userLikes, setUserLikes] = useState<any | null>([]);
    const [fetchTweets, setFetchTweets] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            try {
                if(!wallet) {
                    return;
                }

                // const tweetsPublicKeys = allTweets.map((tweet: { author: any; }) => tweet.author);
                const fetchAllLikes = await program.account.like.all();
                // console.log("FETCH ALL LIKES", fetchAllLikes);
                    setAllLikes(fetchAllLikes);
                
                
                const likedByUser = await program.account.like.all([
                    {
                        memcmp: {
                            offset: 8,
                            bytes: wallet?.publicKey.toString()
                        }
                    }
                ])

                
                    setUserLikes(likedByUser);
            }catch(err) {
                console.log(err);
            }
            setFetchTweets(false);
        })();
    },[wallet, fetchTweets]);

    const setLikes = (likes: Array<any>) => {
        setAllLikes(likes)
    }
    const setFetch = () => {
        setFetchTweets(true);
      }
    const value = {allLikes,fetchTweets, setFetch, setLikes, userLikes}
return (
    <LikeContext.Provider value={value}>{children}</LikeContext.Provider>
)

}

export default LikesProvider;